export default __webpack_public_path__ + "static/media/5.83cb502f.png";